import {InputText} from '@/components/Form/index.mjs'
import FormItemBizProp from '../components/FormItemBizProp.jsx'
import FormChooseDesign from '../_DESIGN/FormChooseDesign.jsx'
import {FormItemArName} from '../AMAR/FormChooseAmar.jsx'
import Model from './ModelArri.mjs'

export const FormItemRiName = props => (
    <FormItemBizProp
        Model={Model}
        prop="riName"
        {...props}
    >
        <InputText allowClear />
    </FormItemBizProp>
)

export const FormItemRiUserCode = props => (
    <FormItemBizProp
        Model={Model}
        prop="riUserCode"
        {...props}
    >
        <InputText allowClear />
    </FormItemBizProp>
)

export default function FormChooseArri(props) {
    return (
        <FormChooseDesign {...props}>
            <FormItemArName />
            <FormItemRiName />
            <FormItemRiUserCode />
        </FormChooseDesign>
    )
}
